/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Query Service
 * Query Service Api Documentation
 *
 * The version of the OpenAPI document: 9.1.6
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from "axios";
import { Configuration } from "./../../../../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./../../../../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./../../../../base";
// @ts-ignore
import { ProductDetail } from "./../../../../com/hcl/commerce/typescript/axios";
/**
 * V2ProductResourceApi - axios parameter creator
 * @export
 */
export const V2ProductResourceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Gets Products
     * @param {string} storeId
     * @param {string} [categoryId]
     * @param {string} [searchTerm]
     * @param {Array<string>} [id]
     * @param {string} [productId]
     * @param {Array<string>} [partNumber]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [associationType]
     * @param {string} [attributeKeyword]
     * @param {string} [catalogId]
     * @param {string} [contractId]
     * @param {string} [currency]
     * @param {string} [langId]
     * @param {boolean} [checkEntitlement]
     * @param {string} [attachmentFilter]
     * @param {string} [profileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findProducts: async (
      storeId: string,
      categoryId?: string,
      searchTerm?: string,
      id?: Array<string>,
      productId?: string,
      partNumber?: Array<string>,
      limit?: number,
      offset?: number,
      associationType?: string,
      attributeKeyword?: string,
      catalogId?: string,
      contractId?: string,
      currency?: string,
      langId?: string,
      checkEntitlement?: boolean,
      attachmentFilter?: string,
      profileName?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists("findProducts", "storeId", storeId);
      const localVarPath = `/api/v2/products`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var back = false;
      window.onpopstate = (e) => {
        /*console.log("onpopstate2");*/
        window.isBack = true;
      };

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (storeId !== undefined) {
        localVarQueryParameter["storeId"] = storeId;
      }

      if (categoryId !== undefined) {
        localVarQueryParameter["categoryId"] = categoryId;
      }

      if (searchTerm !== undefined) {
        if (
          /^\d+[-]{1}\d+$/.test(searchTerm) ||
          /^\d+[-]{1}\d+[-]{1}[T]\d+$/.test(searchTerm)
        ) {
          localVarQueryParameter["partNumber"] = searchTerm;
        } else {
          localVarQueryParameter["searchTerm"] = searchTerm;
        }
      }

      if (id) {
        localVarQueryParameter["id"] = id;
      }

      if (productId !== undefined) {
        localVarQueryParameter["productId"] = productId;
      }

      if (partNumber) {
        localVarQueryParameter["partNumber"] = partNumber;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      var limitBack = limit !== undefined ? limit : 0;
      //Se regresa paginado actual
      var isBack = localStorage.getItem("isBack")
        ? localStorage.getItem("isBack")
        : null;
      if (offset !== undefined) {
        /*console.log("print offset");
        console.log(offset);*/
        localVarQueryParameter["offset"] = offset;
        if (window.selectedPage && (window.isBack || isBack == "true"))
          localVarQueryParameter["offset"] =
            window.selectedPage * limitBack - limitBack;
      } else {
        /*console.log("print offset else");*/
        if (window.selectedPage && (window.isBack || isBack == "true"))
          localVarQueryParameter["offset"] =
            window.selectedPage * limitBack - limitBack;
      }

      if (associationType !== undefined) {
        localVarQueryParameter["associationType"] = associationType;
      }

      if (attributeKeyword !== undefined) {
        localVarQueryParameter["attributeKeyword"] = attributeKeyword;
      }

      if (catalogId !== undefined) {
        localVarQueryParameter["catalogId"] = catalogId;
      }

      if (contractId !== undefined) {
        localVarQueryParameter["contractId"] = contractId;
      }

      if (currency !== undefined) {
        localVarQueryParameter["currency"] = currency;
      }

      if (langId !== undefined) {
        localVarQueryParameter["langId"] = langId;
      }

      if (checkEntitlement !== undefined) {
        localVarQueryParameter["checkEntitlement"] = checkEntitlement;
      }

      if (attachmentFilter !== undefined) {
        localVarQueryParameter["attachmentFilter"] = attachmentFilter;
      }

      if (profileName !== undefined) {
        localVarQueryParameter["profileName"] = profileName;
      }
      localVarQueryParameter["searchSource"] = "E";

      //Se agrega filtro por Mas nuevo
      /*console.log("localVarQueryParameter");*/
      if (!window.orderSort) {
        if (!window.location.search.includes("?searchTerm=")) {
          localVarQueryParameter["orderBy"] = "5";
        } else {
          localVarQueryParameter["orderBy"] = "1";
        }
      } else {
        localVarQueryParameter["orderBy"] = window.orderSort;
      }

      /*console.log(localVarQueryParameter["orderBy"]);*/

      //Se agrega filtrado por url
      if (
        window.location.href.includes("facet=") &&
        (window.clearAll == undefined || !window.clearAll)
      ) {
        var count = 0;
        if (window.location.href.includes("searchTerm")) {
          var newUrl = window.location.href.split("facet=");
          newUrl.map((data) => {
            if (data.includes("raw") || data.includes("TO")) {
              if (count == 0) {
                localVarQueryParameter["filtrosUrl"] = data.replace("&", "");
              } else {
                localVarQueryParameter["filtrosUrl"] += "&facet=" + data;
              }
              count++;
            }
          });
        } else {
          var newUrl = window.location.href.split("facet=");
          newUrl.map((data) => {
            if (data.includes("raw") || data.includes("TO")) {
              if (count == 0) {
                localVarQueryParameter["filtrosUrl"] = data.replace("&", "");
              } else {
                localVarQueryParameter["filtrosUrl"] += "&facet=" + data;
              }
              count++;
            }
          });
        }
      }

      /*console.log("seacrh prueba1");
      console.log(localVarUrlObj);
      console.log(localVarQueryParameter);
      console.log(options.query);*/
      if (options != undefined && options.query && options.query["orderBy"]) {
        delete options.query["orderBy"];
      }
      // console.log("Creando petición");
      // console.log("localVarUrlObj", localVarUrlObj);
      // console.log("options.query", options.query);
      // console.log("localVarQueryParameter", localVarQueryParameter);
      if (
        localVarQueryParameter.filtrosUrl != undefined &&
        localVarQueryParameter.filtrosUrl != null &&
        typeof localVarQueryParameter.filtrosUrl == "string"
      ) {
        // console.log("filtrosUrl", localVarQueryParameter.filtrosUrl);
        if (localVarQueryParameter.filtrosUrl.includes("price_mxn")) {
          // console.log("localVarQueryParameter contiene price_mxn");
          //Lo elimina del query param
          const params = window.location.search.split("?")[1];
          const arrayFacets = params.split(/(?=&)/);
          let priceFilter = arrayFacets.filter((facet) =>
            facet.includes("price_mxn")
          )[0];
          if (options.query == undefined) {
            options.query = { minPrice: "" };
          }
          if (priceFilter != undefined) {
            let minPrice = options.query["minPrice"];
            if (
              options.query["minPrice"] == undefined ||
              options.query["minPrice"] == -1 ||
              options.query["minPrice"] == ""
            ) {
              minPrice = priceFilter.split("+")[0].split("B")[1];
              // console.log("minPrice calculado", minPrice);
              if (minPrice === "*") minPrice = "1";
              options.query["minPrice"] = minPrice;
            }
            if (
              options.query["maxPrice"] == undefined ||
              options.query["maxPrice"] == -1 ||
              options.query["maxPrice"] == ""
            ) {
              let maxPrice = priceFilter.split("+")[2].split("%")[0];
              // console.log("maxPrice calculado", maxPrice);
              if (maxPrice === "*")
                maxPrice = (parseInt(minPrice) + 300).toString();
              options.query["maxPrice"] = maxPrice;
            }
            if (options.query.facet !== undefined) {
              let facetFilterPrice = options.query.facet.filter((facet) =>
                facet.includes("price_mxn")
              );
              if (
                facetFilterPrice !== undefined &&
                facetFilterPrice.length === 1
              ) {
                options.query.facet.splice(
                  options.query.facet.indexOf(facetFilterPrice[0]),
                  1
                );
              }
            }
          }

          // console.log("Se crean los query param de precio", options.query);
          // console.log("Se quita el facet price_mxn del payload");
          // console.log("Antes", localVarQueryParameter.filtrosUrl);
          // console.log("Price filter", priceFilter);
          if (localVarQueryParameter.filtrosUrl.includes(priceFilter)) {
            localVarQueryParameter.filtrosUrl =
              localVarQueryParameter.filtrosUrl.replace(priceFilter, "");
          } else {
            // console.log(
            //   "El priceFilter es el primero y tiene un facet= y no lo detecta"
            // );
            priceFilter = priceFilter.split("facet=")[1];
            // console.log(priceFilter, "priceFILTER --------");
            localVarQueryParameter.filtrosUrl =
              localVarQueryParameter.filtrosUrl.replace(priceFilter, "");
            // console.log(
            //   localVarHeaderParameter.filtrosUrl,
            //   "localVarHeaderParameter.filtrosUrl --------"
            // );

            if (localVarQueryParameter.filtrosUrl.charAt(0) == "&") {
              // console.log(
              //   "entré al if de localVarQueryParameter.filtrosUrl.charAt(0) == & "
              // );
              localVarQueryParameter.filtrosUrl =
                localVarQueryParameter.filtrosUrl.split("&facet=")[1];
            }
          }
          // console.log("Despues", localVarQueryParameter.filtrosUrl);
        }
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      localStorage.setItem("isBack", "false");
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * V2ProductResourceApi - functional programming interface
 * @export
 */
export const V2ProductResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    V2ProductResourceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Gets Products
     * @param {string} storeId
     * @param {string} [categoryId]
     * @param {string} [searchTerm]
     * @param {Array<string>} [id]
     * @param {string} [productId]
     * @param {Array<string>} [partNumber]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [associationType]
     * @param {string} [attributeKeyword]
     * @param {string} [catalogId]
     * @param {string} [contractId]
     * @param {string} [currency]
     * @param {string} [langId]
     * @param {boolean} [checkEntitlement]
     * @param {string} [attachmentFilter]
     * @param {string} [profileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findProducts(
      storeId: string,
      categoryId?: string,
      searchTerm?: string,
      id?: Array<string>,
      productId?: string,
      partNumber?: Array<string>,
      limit?: number,
      offset?: number,
      associationType?: string,
      attributeKeyword?: string,
      catalogId?: string,
      contractId?: string,
      currency?: string,
      langId?: string,
      checkEntitlement?: boolean,
      attachmentFilter?: string,
      profileName?: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetail>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findProducts(
        storeId,
        categoryId,
        searchTerm,
        id,
        productId,
        partNumber,
        limit,
        offset,
        associationType,
        attributeKeyword,
        catalogId,
        contractId,
        currency,
        langId,
        checkEntitlement,
        attachmentFilter,
        profileName,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * V2ProductResourceApi - factory interface
 * @export
 */
export const V2ProductResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = V2ProductResourceApiFp(configuration);
  return {
    /**
     *
     * @summary Gets Products
     * @param {string} storeId
     * @param {string} [categoryId]
     * @param {string} [searchTerm]
     * @param {Array<string>} [id]
     * @param {string} [productId]
     * @param {Array<string>} [partNumber]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [associationType]
     * @param {string} [attributeKeyword]
     * @param {string} [catalogId]
     * @param {string} [contractId]
     * @param {string} [currency]
     * @param {string} [langId]
     * @param {boolean} [checkEntitlement]
     * @param {string} [attachmentFilter]
     * @param {string} [profileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findProducts(
      storeId: string,
      categoryId?: string,
      searchTerm?: string,
      id?: Array<string>,
      productId?: string,
      partNumber?: Array<string>,
      limit?: number,
      offset?: number,
      associationType?: string,
      attributeKeyword?: string,
      catalogId?: string,
      contractId?: string,
      currency?: string,
      langId?: string,
      checkEntitlement?: boolean,
      attachmentFilter?: string,
      profileName?: string,
      options?: any
    ): AxiosPromise<ProductDetail> {
      return localVarFp
        .findProducts(
          storeId,
          categoryId,
          searchTerm,
          id,
          productId,
          partNumber,
          limit,
          offset,
          associationType,
          attributeKeyword,
          catalogId,
          contractId,
          currency,
          langId,
          checkEntitlement,
          attachmentFilter,
          profileName,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * V2ProductResourceApi - object-oriented interface
 * @export
 * @class V2ProductResourceApi
 * @extends {BaseAPI}
 */
export class V2ProductResourceApi extends BaseAPI {
  /**
   *
   * @summary Gets Products
   * @param {string} storeId
   * @param {string} [categoryId]
   * @param {string} [searchTerm]
   * @param {Array<string>} [id]
   * @param {string} [productId]
   * @param {Array<string>} [partNumber]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [associationType]
   * @param {string} [attributeKeyword]
   * @param {string} [catalogId]
   * @param {string} [contractId]
   * @param {string} [currency]
   * @param {string} [langId]
   * @param {boolean} [checkEntitlement]
   * @param {string} [attachmentFilter]
   * @param {string} [profileName]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof V2ProductResourceApi
   */
  public findProducts(
    storeId: string,
    categoryId?: string,
    searchTerm?: string,
    id?: Array<string>,
    productId?: string,
    partNumber?: Array<string>,
    limit?: number,
    offset?: number,
    associationType?: string,
    attributeKeyword?: string,
    catalogId?: string,
    contractId?: string,
    currency?: string,
    langId?: string,
    checkEntitlement?: boolean,
    attachmentFilter?: string,
    profileName?: string,
    options?: any
  ) {
    return V2ProductResourceApiFp(this.configuration)
      .findProducts(
        storeId,
        categoryId,
        searchTerm,
        id,
        productId,
        partNumber,
        limit,
        offset,
        associationType,
        attributeKeyword,
        catalogId,
        contractId,
        currency,
        langId,
        checkEntitlement,
        attachmentFilter,
        profileName,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
